<div class="theme-toggle-container">
  <p-button 
    [icon]="getThemeIcon()"
    [label]="getThemeDisplayName()"
    styleClass="p-button-text p-button-sm theme-toggle-btn"
    [pTooltip]="'Theme: ' + getThemeDisplayName()"
    tooltipPosition="bottom"
    (onClick)="toggleThemeMenu($event)"
    [ariaLabel]="'Current theme: ' + getThemeDisplayName() + '. Click to change theme.'"
  ></p-button>

  <p-menu 
    id="theme_toggle_id"
    #themeMenu 
    [appendTo]="'body'"
    [model]="themeMenuItems" 
    [popup]="true"
    styleClass="theme-menu"
  ></p-menu>
</div>